import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { useEffect } from "react";

import { useBFFProductServiceApi } from "@/api/hooks/productService.hook";
import { Spinner } from "@/components/General/Spinner/spinner.component";

import Calculation from "./calculation/calculation.component";
import {
    ConfigurationSkuList,
    useCorrugatedSheetCalculation
} from "./corrugatedSheetCalculation";
import Result from "./result/result.component";
import { CorrugatedSheetShoppingListComponent } from "./shoppinglist/corrugatedSheet.shoppingList.component";

const CorrugatedSheetCalculator = () => {
    const {
        setHeight,
        setLength,
        setWidth,
        setProductLine,
        setIsTwoSidedRoof,
        setColor,
        setProductData,
        toggleAcc,
        height,
        length,
        width,
        productLine,
        isTwoSidedRoof,
        result,
        hasValidResult,
        color,
        activeAcc
    } = useCorrugatedSheetCalculation();

    const [{ data, loading }, getProducts] = useBFFProductServiceApi<
        any,
        any,
        Array<Product<ProductFieldSet.ProductTile>>
    >(
        {
            params: {
                sku: ConfigurationSkuList.join(","),
                fields: ProductFieldSet.ProductTile
            },
            url: `/products`,
            method: "GET"
        },
        { autoCancel: false, manual: true, useCache: false }
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        getProducts();
    }, []);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setProductData(data || []);
    }, [data]);

    return (
        <div id="calculator">
            {loading && <Spinner />}
            {!loading && (
                <>
                    <Calculation
                        setHeight={setHeight}
                        setLength={setLength}
                        setWidth={setWidth}
                        setProductLine={setProductLine}
                        setIsTwoSidedRoof={setIsTwoSidedRoof}
                        setColor={setColor}
                        height={height}
                        length={length}
                        width={width}
                        productLine={productLine}
                        isTwoSidedRoof={isTwoSidedRoof}
                        color={color}
                    />
                    {hasValidResult && (
                        <>
                            <Result
                                result={result}
                                mailParams={{
                                    roofHeight: height,
                                    roofWidth: width,
                                    rootLength: length,
                                    productLine,
                                    isTwoSidedRoof: isTwoSidedRoof.toString(),
                                    color: color?.toString() || ""
                                }}
                            />
                            <CorrugatedSheetShoppingListComponent
                                result={result}
                                toggleAcc={toggleAcc}
                                activeAcc={activeAcc}
                            />
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export { CorrugatedSheetCalculator };
